import i18n from "@/i18n";
import { AuthHistorySources } from "../data/enums/authHistorySources";

/**Состояние карты */
export default function authHistorySource(
  authHistorySource: AuthHistorySources
): string {
  let source: string = "";
  switch (authHistorySource) {
    case AuthHistorySources.HtmlClient:
      source = i18n.t("main.authHistory.sources.htmlClient").toString();
      break;
    case AuthHistorySources.Mobile:
      source = i18n.t("main.authHistory.sources.mobile").toString();
      break;
    default:
      source = "-";
      break;
  }

  return source;
}
